import { WorldLine2 } from '@strava/mre';

import { LatLng } from '../types';

export const getWorldLine2FromLatLngArray: (points: LatLng[]) => WorldLine2 = (
  points
) => {
  return {
    points: points.map(([latitude, longitude]) => ({ latitude, longitude }))
  };
};
